import React from 'react';
import clsx from 'clsx';
import { IProps, IStatsCard } from './StatsCardBlock.interface';
import '@/blocks/StatsCardBlock/StatsCardBlock.styles.css';
import BlockWrapper from '@/layouts/BlockWrapper/BlockWrapper.component';
import ContentWrapper, { ContentColumn } from '@/layouts/ContentWrapper/ContentWrapper.component';
import Heading from '@/elements/Heading/Heading.component';
import Text from '@/elements/Text/Text.component';
import Button from '@/elements/Button/Button.component';
import Icon from '@/elements/Icon/Icon.component';

const StatsCard: React.FC<IStatsCard> = ({ icon, stat, description, layout = 'vertical' }) => (
    <div className="statsCardBlock__card">
        <div className={`statsCardBlock__card__layout--${layout}`}>
            {icon && <Icon icon={icon} className="statsCardBlock__card--icon" aria-hidden="true" />}
            {stat && <Heading level={3} html={stat} className="statsCardBlock__card--stat" />}
        </div>
        {description && layout !== 'horizontal' ? <Text as='div' html={description} className="statsCardBlock__card--description" /> : null}
    </div>
);

const StatsCardBlock: React.FC<IProps> = (props) => {
    const {
        className,
        title,
        description,
        stats,
        notes,
        buttons,
        statsLayout = 'vertical',
        ...blockWrapperProps
    } = props;

    return (
        <BlockWrapper className={clsx('statsCardBlock', className)} {...blockWrapperProps}>
            <ContentWrapper>
                <ContentColumn>
                    {title && (
                        <Heading level={2} className="statsCardBlock__heading" html={title} />
                    )}
                    {description && (
                        <Text className="statsCardBlock__description" html={description} />
                    )}
                    {stats && stats.length > 0 && (
                        <div className={clsx("statsCardBlock__cards", `statsCardBlock__cards--${statsLayout}`)}>
                            {stats.slice(0, 4).map((card, idx) => (
                                <StatsCard key={`stats-card-block-card-${idx}`} {...card} layout={statsLayout} />
                            ))}
                        </div>
                    )}
                    {notes && (
                        <Text html={notes} className="statsCardBlock__notes" />
                    )}
                    {buttons && buttons.length > 0 && (
                        <div className="statsCardBlock__buttons">
                            {buttons.map((btn, idx) => (
                                <Button key={`stats-card-block-cta-${idx}`} {...btn} />
                            ))}
                        </div>
                    )}
                </ContentColumn>
            </ContentWrapper>
        </BlockWrapper>
    );
};

export { StatsCardBlock };
